import React, { Component } from 'react';
import { formatoDecimal } from '../../../utilities/formatoNumeros'
import { switchCardEstado } from "../../../helper/publicacionHelper";
import './PublicacionStyles.css';
import PropTypes from 'prop-types';

export default class PublicacionListItem extends Component {
    render = () => {
        const {
            idPublicacion,
            titulo,
            skuSeller,
            skuMarket,
            categoria,
            precioLista,
            precioPromocional,
            estado,
            img,
            marca,
            envioGratis,
            handleEstado,
            tipoEntrega,
            fechaPublicacion,
            descripcionSeller,
            tipoPublicacion,
            stock,
            isAdminOrCategory,
            productoExceptuado,
            onOrdenes,
            hideCheckboxEstado,
            hideBtnOrdenes,
            descripcionUmbralStock
        } = this.props;

        // Aseguramos que sean strings para evitar error de React
        const marcaStr = typeof marca === 'object' && marca !== null ? (marca.nombre ?? JSON.stringify(marca)) : marca;
        const categoriaStr = typeof categoria === 'object' && categoria !== null ? (categoria.nombre ?? JSON.stringify(categoria)) : categoria;
        const tipoPublicacionStr = typeof tipoPublicacion === 'object' && tipoPublicacion !== null ? (tipoPublicacion.nombre ?? JSON.stringify(tipoPublicacion)) : tipoPublicacion;

        // Si el estado es string, lo convertimos a id
        let estadoId = estado;
        if (typeof estado === 'string') {
            // Importar el helper
            // eslint-disable-next-line
            const { getIdEstadoPublicacion } = require("../../../helper/publicacionHelper");
            estadoId = getIdEstadoPublicacion(estado);
        }
        const { text, color } = switchCardEstado(estadoId);

        let stockTier = "alto";
        if (stock <= 0) {
            stockTier = "sin";
        } else if (descripcionUmbralStock === "Stock Bajo") {
            stockTier = "bajo";
        } else if (descripcionUmbralStock === "Sin Stock") {
            stockTier = "sin";
        }

        let labelEstado =
            <div>
                <span className={`label label-item label-${color}`}>{text}</span>
            </div>
            ;

        let checkboxEstado =
            <button
                style={{ border: "none", background: "none" }}
                className="custom-control form-switch"
                onClick={(e) => handleEstado(e, { idPublicacion: idPublicacion, estado: estado, skuSeller: skuSeller, stock: stock })}
            >
                <input
                    id={idPublicacion}
                    type="checkbox"
                    className="form-check-input"
                    defaultChecked={estado === "activo"}
                />
                <label htmlFor={idPublicacion} className="custom-control-label text-capitalize d-block">
                    <span className={`label label-item label-${color}`}>{text}</span>
                </label>
            </button>
            ;


        let btnOrdenes =
            <div className='mt-2 font-14 applyFont'>
                <button
                    style={{ border: "none", background: "none" }}
                    onClick={(e) => onOrdenes(e, this.props.skuMarket)}
                    className="sl-icon-basket text-decoration-none fs-6 color-rojo-megatone me-1"
                >
                Ordenes
                </button>
            </div >
            ;



        return (
            <div className={`list-group-item publicacion-card publicacion-card--stock-${stockTier}`}>
                <div className="row p-2 align-items-center publicacion-card__inner">

                    <div className="col-8 col-md-2 text-center text-break">
                        <div className="displayInlineTable">
                            <h6 className="font-weight-bold">{descripcionSeller}</h6>
                            <span className="font-size-072rem">{fechaPublicacion ? fechaPublicacion.substr(0, 10) : ""}</span>
                            <br></br><span className="font-size-072rem">{idPublicacion}</span>
                        </div>
                    </div>

                    <div className="col-4 col-md-1 text-center">
                        <img className="mw-60px" alt={titulo.substring(0, 10) + "..."} src={img} />
                    </div>

                    <div className="col-12 col-md-9 p-md-0 p-4">
                        <div className="row px-1">

                            <div className="col-12">
                                <h6 className="box-title m-b-5 font-weight-bold">{titulo}</h6>
                            </div>

                            <div className="col-12 col-md-6 pb-lg-0 pb-md-0 pb-4">
                                <small className="applyFont">{marcaStr} - {categoriaStr}</small>
                                <small className="d-block mt-1">
                                    SKU Seller: {skuSeller} | SKU Market: {skuMarket}
                                </small>
                                <small className="d-block mt-1">
                                    <b>Tipo publicación: </b>{tipoPublicacionStr}
                                </small>
                                <div className="mt-1">
                                    {(() => {
                                        let stockClass = "stock-alto";
                                        let stockText = "Stock Alto";

                                        if (stock <= 0 || descripcionUmbralStock === "Sin Stock") {
                                            stockClass = "sin-stock";
                                            stockText = "Sin Stock";
                                        } else if (descripcionUmbralStock === "Stock Bajo") {
                                            stockClass = "stock-bajo";
                                            stockText = "Stock Bajo";
                                        } else if (descripcionUmbralStock === "Sin Stock") {
                                            stockClass = "sin-stock";
                                            stockText = "Sin Stock";
                                        }

                                        return (
                                            <span className={`stock-indicator ${stockClass}`}>
                                                Stock: {stock} — {stockText}
                                            </span>
                                        );
                                    })()}
                                </div>
                            </div>

                            <div className="col-4 col-md-2 text-center">
                                <small className="font-14 applyFont">
                                    {tipoEntrega ?? ""}
                                </small>
                                <br />
                                <small className="font-14 applyFont">
                                    {(envioGratis) ? "Envio Gratis" : ""}
                                </small>
                            </div>

                            <div className="col-4 col-md-2 text-center">
                                <h6 className="font-weight-bold box-title m-b-0">
                                    $ {(precioPromocional) ? formatoDecimal(precioPromocional) : formatoDecimal(precioLista)}
                                </h6>
                                <small className="font-size-10px">Precio Publicado</small>
                            </div>

                            <div className="col-4 col-md-2 text-center">
                                {/* Si está oculto el switch, muestra solo el label de estado */}
                                {hideCheckboxEstado && labelEstado}
                                {!hideCheckboxEstado && (isAdminOrCategory ? checkboxEstado : labelEstado)}
                                {isAdminOrCategory && productoExceptuado &&
                                    <small className="label label-item label-red mt-1 p-1">
                                        PRODUCTO <br /> EXCEPTUADO
                                    </small>
                                }
                                {/* Oculta el botón de órdenes si hideBtnOrdenes es true */}
                                {!hideBtnOrdenes && btnOrdenes}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
PublicacionListItem.propTypes = {
    idPublicacion: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    titulo: PropTypes.string,
    skuSeller: PropTypes.number,
    skuMarket: PropTypes.number,
    categoria: PropTypes.shape({
        nombre: PropTypes.string,
    }),
    precioLista: PropTypes.string,
    precioPromocional: PropTypes.string,
    estado: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    img: PropTypes.string,
    marca: PropTypes.shape({
        nombre: PropTypes.string,
    }),
    envioGratis: PropTypes.bool,
    handleEstado: PropTypes.func,
    tipoEntrega: PropTypes.string,
    fechaPublicacion: PropTypes.string,
    descripcionSeller: PropTypes.string,
    tipoPublicacion: PropTypes.shape({
        nombre: PropTypes.string,
    }),
    stock: PropTypes.number,
    isAdminOrCategory: PropTypes.bool,
    productoExceptuado: PropTypes.bool,
    onOrdenes: PropTypes.func,
    hideCheckboxEstado: PropTypes.bool,
    hideBtnOrdenes: PropTypes.bool,
    descripcionUmbralStock: PropTypes.string,
}